export default __webpack_public_path__ + "9327bedc6cb0f14ce4278e80f0e9c8b7.png";